import { ARCADE_ACCENT } from "./triviaArcade";

export const TRIVIA_RESULTS_SAFE_PADDING_BOTTOM =
  "max(32px, calc(24px + env(safe-area-inset-bottom, 0px)))";

export const arcadeFilledButtonSx = {
  bgcolor: ARCADE_ACCENT,
  color: "#fff",
  fontWeight: 700,
  "&:hover": { bgcolor: "#db2777" },
};

export const arcadeOutlinedButtonSx = {
  color: ARCADE_ACCENT,
  borderColor: "rgba(236, 72, 153, 0.55)",
  fontWeight: 700,
  "&:hover": {
    borderColor: ARCADE_ACCENT,
    bgcolor: "rgba(236, 72, 153, 0.08)",
  },
};
